<template>
  <v-menu
    ref="datesPickerMenu"
    v-model="showDatesPicker"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="datesText"
        :label="$t('booking.dates')"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        color="grey"
        clearable
        @click:clear="onClearClicked"
      />
    </template>
    <v-date-picker
      v-model="dates"
      no-title
      scrollable
      :locale="$i18n.locale"
      color="red darken-1"
      range
    />
  </v-menu>
</template>

<script>
import { DateTime, Interval } from "luxon";
import i18n from "@/i18n";

export default {
  name: "DateRangeFilter",
  components: {},
  props: {},
  data: () => ({
    showDatesPicker: false,
    dates: null,
  }),
  computed: {
    dateStart() {
      return this.dates[0];
    },
    dateEnd() {
      return this.dates.length === 1 ? this.dates[0] : this.dates[1];
    },
    isSingleDate() {
      return (
        this.dates.length === 1 ||
        (this.dates.length === 2 && this.dates[0] === this.dates[1])
      );
    },
    isDateRange() {
      return this.dates.length === 2 && this.dates[0] !== this.dates[1];
    },
    datesText() {
      if (!this.dates) return null;
      if (this.isSingleDate) return this.formatDateShort(this.dateStart);
      else if (this.isDateRange)
        return i18n
          .t("booking.dateRange")
          .replace("%1", this.formatDateShort(this.dateStart))
          .replace("%2", this.formatDateShort(this.dateEnd));
      return this.dates.join(" ~ ");
    },
  },
  methods: {
    formatDateShort(date) {
      return DateTime.fromISO(date)
        .setLocale(this.$i18n.locale)
        .toLocaleString(DateTime.DATE_SHORT);
    },
    ensureDatesOrder(dates) {
      if (dates?.length === 2) {
        const dateFrom = DateTime.fromISO(dates[0]);
        const dateTo = DateTime.fromISO(dates[1]);
        if (dateTo < dateFrom) {
          const temp = this.dates[0];
          this.dates[0] = this.dates[1];
          this.dates[1] = temp;
        }
      }
    },
    ensureDatesRange() {
      if (this.dates?.length === 1) this.dates.push(this.dates[0]);
    },

    onDateTimeInput() {
      this.$emit(
        "updateFilter",
        Interval.fromDateTimes(
          DateTime.fromFormat(`${this.dates[0]}&9:00`, "yyyy-MM-dd&H:mm"),
          DateTime.fromFormat(`${this.dates[1]}&18:00`, "yyyy-MM-dd&H:mm")
        )
      );
    },
    onClearClicked() {
      this.dates = null;
      this.$emit("updateFilter", null);
    },
  },
  watch: {
    dates(newValue) {
      this.ensureDatesOrder(newValue);
    },
    showDatesPicker(open) {
      if (!open && this.dates) {
        this.ensureDatesRange();
        this.onDateTimeInput();
      }
    },
  },
};
</script>
